import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [data, setData] = useState({ site: null, services: [], gallery: [] });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.get("/site");
      setData(res.data);
    } catch (e) {
      console.error("Failed to load site content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <SiteContext.Provider value={{ ...data, loading, reload: load }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
